var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { Icon, Input } from '../../index.react';
import { default as ReactDatePicker } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { createStyle } from './createStyle';

var DatePicker = function DatePicker(props) {
  var forwardedRef = props.forwardedRef,
      inputProps = props.inputProps,
      selected = props.selected,
      disabled = props.disabled,
      datePickerProps = __rest(props, ["forwardedRef", "inputProps", "selected", "disabled"]);

  return React.createElement("div", {
    className: createStyle({
      disabled: disabled
    })
  }, React.createElement(ReactDatePicker, __assign({}, datePickerProps, {
    disabled: props.disabled,
    selected: selected,
    placeholderText: "Select date",
    customInput: React.createElement(Input, __assign({}, inputProps, {
      disabled: props.disabled,
      ref: forwardedRef,
      icoRight: React.createElement(Icon, {
        name: "calendar",
        size: "s",
        style: {
          marginBottom: 1
        }
      })
    }))
  })));
};

export default React.forwardRef(function (props, forwardedRef) {
  return React.createElement(DatePicker, __assign({}, props, {
    forwardedRef: forwardedRef
  }));
});